import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.find.js";
import * as echarts from "echarts";
import { extractLoginData } from "../unit/UserUtil";
import { getMexcTradingRobotConfigs, getMexcTradingRobotTradeOrders } from "../apis/services/mexcTradingRobot";
var ADMIN_USER_NAME = "boylikegirl";
var ALL_PAGE_SIZE = 2000;
export default {
  data: function data() {
    return {
      loading: false,
      configs: [],
      orders: [],
      totalCount: 0,
      loadedCount: 0,
      currentUserName: "",
      searchTimer: null,
      chartInstances: [],
      filters: {
        symbol: "",
        cexName: "",
        status: "",
        innerStatus: "",
        sampleSize: 500
      },
      innerStatusOptions: [{
        value: 0,
        label: "0 交易结束"
      }, {
        value: 1,
        label: "1 交易中"
      }, {
        value: 2,
        label: "2 已过期"
      }, {
        value: 3,
        label: "3 已取消"
      }, {
        value: 4,
        label: "4 彻底结束"
      }]
    };
  },
  computed: {
    canViewPage: function canViewPage() {
      return this.currentUserName === ADMIN_USER_NAME;
    },
    isAllSample: function isAllSample() {
      return this.filters.sampleSize === "all";
    },
    sampleLabel: function sampleLabel() {
      return this.isAllSample ? "全部订单" : "\u6700\u8FD1 ".concat(this.orders.length, " \u5355");
    },
    symbolOptions: function symbolOptions() {
      return this.uniqueValues(this.configs.concat(this.orders), "symbol");
    },
    cexNameOptions: function cexNameOptions() {
      return this.uniqueValues(this.configs.concat(this.orders), "cexName");
    },
    activeConfigCount: function activeConfigCount() {
      return this.filteredConfigs.filter(function (item) {
        return !item.isStop;
      }).length;
    },
    filteredConfigs: function filteredConfigs() {
      var _this = this;

      return this.configs.filter(function (item) {
        var symbolMatched = !_this.filters.symbol || item.symbol === _this.filters.symbol;
        var cexNameMatched = !_this.filters.cexName || item.cexName === _this.filters.cexName;
        return symbolMatched && cexNameMatched;
      });
    },
    sortedOrders: function sortedOrders() {
      var _this2 = this;

      return _toConsumableArray(this.orders).sort(function (a, b) {
        var idA = _this2.toNumber(a.id);

        var idB = _this2.toNumber(b.id);

        if (idA !== idB) return idB - idA;
        return new Date(b.creationTime) - new Date(a.creationTime);
      });
    },
    filledOrders: function filledOrders() {
      return this.orders.filter(function (item) {
        return item.status === "FILLED";
      }).length;
    },
    canceledOrders: function canceledOrders() {
      return this.orders.filter(function (item) {
        return item.status === "CANCELED";
      }).length;
    },
    runningOrders: function runningOrders() {
      return this.orders.filter(function (item) {
        return Number(item.innerStatus) === 1;
      }).length;
    },
    trappedOrders: function trappedOrders() {
      var _this3 = this;

      return this.sortedOrders.filter(function (item) {
        return _this3.isTrappedOrder(item);
      });
    },
    trappedAmount: function trappedAmount() {
      var _this4 = this;

      return this.trappedOrders.reduce(function (sum, item) {
        return sum + _this4.getOrderAmount(item);
      }, 0);
    },
    trappedAvgDays: function trappedAvgDays() {
      var _this5 = this;

      if (!this.trappedOrders.length) return 0;
      var totalDays = this.trappedOrders.reduce(function (sum, item) {
        return sum + _this5.getTrappedDays(item);
      }, 0);
      return Math.round(totalDays / this.trappedOrders.length * 10) / 10;
    },
    totalQuoteAmount: function totalQuoteAmount() {
      var _this6 = this;

      return this.orders.reduce(function (sum, item) {
        return sum + _this6.toNumber(item.cummulativeQuoteQty);
      }, 0);
    },
    totalProfit: function totalProfit() {
      var _this7 = this;

      return this.orders.reduce(function (sum, item) {
        return sum + _this7.toNumber(item.lastProfit);
      }, 0);
    },
    avgPrice: function avgPrice() {
      var _this8 = this;

      var valid = this.orders.filter(function (item) {
        return _this8.toNumber(item.price) > 0;
      });
      if (!valid.length) return 0;
      return valid.reduce(function (sum, item) {
        return sum + _this8.toNumber(item.price);
      }, 0) / valid.length;
    },
    metrics: function metrics() {
      return [{
        label: "机器人配置",
        value: "".concat(this.activeConfigCount, "/").concat(this.filteredConfigs.length),
        help: "当前筛选下启用配置 / 配置数",
        icon: "ni ni-settings-gear-65",
        color: "bg-gradient-primary"
      }, {
        label: "订单总数",
        value: this.totalCount,
        help: "\u5F53\u524D\u7B5B\u9009\u603B\u6570\uFF1B\u7EDF\u8BA1\u57FA\u4E8E".concat(this.sampleLabel),
        icon: "ni ni-bullet-list-67",
        color: "bg-gradient-info"
      }, {
        label: "成交金额",
        value: this.formatAmount(this.totalQuoteAmount),
        help: "".concat(this.sampleLabel, "\u5185\u7D2F\u8BA1\u6210\u4EA4\u989D"),
        icon: "ni ni-chart-bar-32",
        color: "bg-gradient-success"
      }, {
        label: "最终盈利",
        value: this.formatAmount(this.totalProfit),
        help: "".concat(this.sampleLabel, "\uFF1B\u5E73\u5747\u4EF7\u683C ").concat(this.formatAmount(this.avgPrice)),
        icon: "ni ni-money-coins",
        color: "bg-gradient-warning"
      }, {
        label: "已成交",
        value: this.filledOrders,
        help: "MEXC 状态 FILLED",
        icon: "ni ni-check-bold",
        color: "bg-gradient-success"
      }, {
        label: "交易中",
        value: this.runningOrders,
        help: "内部状态为 1",
        icon: "ni ni-user-run",
        color: "bg-gradient-info"
      }, {
        label: "套牢订单",
        value: this.trappedOrders.length,
        help: "\u5957\u7262\u91D1\u989D ".concat(this.formatAmount(this.trappedAmount), "\uFF1B\u5E73\u5747 ").concat(this.trappedAvgDays, " \u5929"),
        icon: "ni ni-chart-pie-35",
        color: "bg-gradient-danger"
      }, {
        label: "已取消",
        value: this.canceledOrders,
        help: "MEXC 状态 CANCELED",
        icon: "ni ni-fat-remove",
        color: "bg-gradient-danger"
      }, {
        label: "成交率",
        value: "".concat(this.percent(this.filledOrders, this.orders.length), "%"),
        help: "样本内已成交 / 样本数",
        icon: "ni ni-spaceship",
        color: "bg-gradient-default"
      }];
    },
    statusDistribution: function statusDistribution() {
      return this.toDistribution(this.orders, "status");
    },
    symbolDistribution: function symbolDistribution() {
      return this.toDistribution(this.orders, "symbol").slice(0, 8);
    },
    profitBySymbol: function profitBySymbol() {
      var _this9 = this;

      var map = {};
      this.orders.forEach(function (item) {
        var key = item.symbol || "UNKNOWN";

        if (!map[key]) {
          map[key] = {
            name: key,
            profit: 0,
            count: 0
          };
        }

        map[key].profit += _this9.toNumber(item.lastProfit);
        map[key].count += 1;
      });
      return Object.values(map).sort(function (a, b) {
        return b.profit - a.profit;
      }).slice(0, 8);
    },
    trappedBySymbol: function trappedBySymbol() {
      var _this10 = this;

      var map = {};
      this.trappedOrders.forEach(function (item) {
        var key = item.symbol || "UNKNOWN";

        if (!map[key]) {
          map[key] = {
            name: key,
            amount: 0,
            quantity: 0,
            count: 0
          };
        }

        map[key].amount += _this10.getOrderAmount(item);
        map[key].quantity += _this10.toNumber(item.executedQty || item.quantity);
        map[key].count += 1;
      });
      return Object.values(map).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          avgPrice: item.quantity ? item.amount / item.quantity : 0
        });
      }).sort(function (a, b) {
        return b.amount - a.amount;
      }).slice(0, 8);
    },
    trendByDate: function trendByDate() {
      var _this11 = this;

      var map = {};
      this.sortedOrders.slice().reverse().forEach(function (item) {
        var date = _this11.getDateKey(item.creationTime);

        if (!map[date]) {
          map[date] = {
            date: date,
            profit: 0,
            quoteAmount: 0,
            orderCount: 0,
            trappedCount: 0
          };
        }

        map[date].profit += _this11.toNumber(item.lastProfit);
        map[date].quoteAmount += _this11.toNumber(item.cummulativeQuoteQty);
        map[date].orderCount += 1;

        if (_this11.isTrappedOrder(item)) {
          map[date].trappedCount += 1;
        }
      });
      var cumulativeProfit = 0;
      return Object.values(map).sort(function (a, b) {
        return a.date.localeCompare(b.date);
      }).map(function (item) {
        cumulativeProfit += item.profit;
        return _objectSpread(_objectSpread({}, item), {}, {
          cumulativeProfit: cumulativeProfit
        });
      });
    },
    topSymbolsForLine: function topSymbolsForLine() {
      return this.toDistribution(this.orders, "symbol").slice(0, 5).map(function (item) {
        return item.name;
      });
    },
    symbolProfitSeries: function symbolProfitSeries() {
      var _this12 = this;

      var dates = this.trendByDate.map(function (item) {
        return item.date;
      });
      var map = {};
      this.topSymbolsForLine.forEach(function (symbol) {
        map[symbol] = {};
      });
      this.orders.forEach(function (item) {
        var symbol = item.symbol || "UNKNOWN";
        if (!map[symbol]) return;

        var date = _this12.getDateKey(item.creationTime);

        map[symbol][date] = (map[symbol][date] || 0) + _this12.toNumber(item.lastProfit);
      });
      return this.topSymbolsForLine.map(function (symbol) {
        return {
          name: symbol,
          type: "line",
          smooth: true,
          data: dates.map(function (date) {
            return _this12.round(map[symbol][date] || 0);
          })
        };
      });
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: function handler() {
        var _this13 = this;

        if (!this.canViewPage) return;
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(function () {
          _this13.loadData();
        }, 300);
      }
    },
    orders: function orders() {
      var _this14 = this;

      this.$nextTick(function () {
        _this14.renderCharts();
      });
    }
  },
  methods: {
    loadData: function loadData() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var baseQuery, configResult, orderResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this15.canViewPage) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this15.loading = true;
                _this15.loadedCount = 0;
                _context.prev = 4;
                baseQuery = {
                  SkipCount: 0,
                  Sorting: "id desc",
                  symbol: _this15.filters.symbol,
                  cexName: _this15.filters.cexName,
                  status: _this15.filters.status,
                  innerStatus: _this15.filters.innerStatus
                };
                _context.next = 8;
                return getMexcTradingRobotConfigs();

              case 8:
                configResult = _context.sent;

                if (!_this15.isAllSample) {
                  _context.next = 15;
                  break;
                }

                _context.next = 12;
                return _this15.loadAllOrders(baseQuery);

              case 12:
                _context.t0 = _context.sent;
                _context.next = 18;
                break;

              case 15:
                _context.next = 17;
                return getMexcTradingRobotTradeOrders(_objectSpread(_objectSpread({}, baseQuery), {}, {
                  MaxResultCount: _this15.filters.sampleSize
                }));

              case 17:
                _context.t0 = _context.sent;

              case 18:
                orderResult = _context.t0;
                _this15.configs = configResult.items || [];
                _this15.orders = (orderResult.items || []).sort(function (a, b) {
                  var idA = _this15.toNumber(a.id);

                  var idB = _this15.toNumber(b.id);

                  if (idA !== idB) return idB - idA;
                  return new Date(b.creationTime) - new Date(a.creationTime);
                });
                _this15.totalCount = orderResult.totalCount || 0;

              case 22:
                _context.prev = 22;
                _this15.loading = false;
                return _context.finish(22);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4,, 22, 25]]);
      }))();
    },
    loadAllOrders: function loadAllOrders(baseQuery) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var skipCount, totalCount, items, result, pageItems;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                skipCount = 0;
                totalCount = 0;
                items = [];

              case 3:
                _context2.next = 5;
                return getMexcTradingRobotTradeOrders(_objectSpread(_objectSpread({}, baseQuery), {}, {
                  SkipCount: skipCount,
                  MaxResultCount: ALL_PAGE_SIZE
                }));

              case 5:
                result = _context2.sent;
                pageItems = result.items || [];
                totalCount = result.totalCount || items.length + pageItems.length;
                items = items.concat(pageItems);
                _this16.loadedCount = items.length;
                skipCount += pageItems.length;

                if (pageItems.length) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt("break", 14);

              case 13:
                if (items.length < totalCount) {
                  _context2.next = 3;
                  break;
                }

              case 14:
                return _context2.abrupt("return", {
                  items: items,
                  totalCount: totalCount
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    renderCharts: function renderCharts() {
      if (!this.canViewPage) return;
      this.disposeCharts();
      this.renderProfitTrendChart();
      this.renderStatusPieChart();
      this.renderSymbolProfitLineChart();
      this.renderSymbolPieChart();
    },
    renderProfitTrendChart: function renderProfitTrendChart() {
      var _this17 = this;

      var chart = this.createChart("profitTrendChart");
      if (!chart) return;
      var dates = this.trendByDate.map(function (item) {
        return item.date;
      });
      chart.setOption({
        tooltip: {
          trigger: "axis"
        },
        legend: {
          top: 0
        },
        grid: {
          left: 50,
          right: 50,
          bottom: 40,
          top: 45
        },
        xAxis: {
          type: "category",
          data: dates
        },
        yAxis: [{
          type: "value",
          name: "盈利"
        }, {
          type: "value",
          name: "成交额"
        }, {
          type: "value",
          name: "套牢数",
          offset: 45
        }],
        series: [{
          name: "成交金额",
          type: "bar",
          yAxisIndex: 1,
          data: this.trendByDate.map(function (item) {
            return _this17.round(item.quoteAmount);
          }),
          itemStyle: {
            color: "#2dce89"
          }
        }, {
          name: "每日盈利",
          type: "line",
          smooth: true,
          data: this.trendByDate.map(function (item) {
            return _this17.round(item.profit);
          }),
          itemStyle: {
            color: "#fb6340"
          }
        }, {
          name: "累计盈利",
          type: "line",
          smooth: true,
          data: this.trendByDate.map(function (item) {
            return _this17.round(item.cumulativeProfit);
          }),
          itemStyle: {
            color: "#5e72e4"
          }
        }, {
          name: "套牢订单数",
          type: "line",
          yAxisIndex: 2,
          smooth: true,
          data: this.trendByDate.map(function (item) {
            return item.trappedCount;
          }),
          itemStyle: {
            color: "#f5365c"
          }
        }]
      });
    },
    renderStatusPieChart: function renderStatusPieChart() {
      var chart = this.createChart("statusPieChart");
      if (!chart) return;
      chart.setOption({
        tooltip: {
          trigger: "item"
        },
        legend: {
          bottom: 0
        },
        series: [{
          name: "订单状态",
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: true,
          data: this.statusDistribution.map(function (item) {
            return {
              name: item.name,
              value: item.count
            };
          })
        }]
      });
    },
    renderSymbolProfitLineChart: function renderSymbolProfitLineChart() {
      var chart = this.createChart("symbolProfitLineChart");
      if (!chart) return;
      chart.setOption({
        tooltip: {
          trigger: "axis"
        },
        legend: {
          top: 0,
          type: "scroll"
        },
        grid: {
          left: 50,
          right: 30,
          bottom: 40,
          top: 50
        },
        xAxis: {
          type: "category",
          data: this.trendByDate.map(function (item) {
            return item.date;
          })
        },
        yAxis: {
          type: "value",
          name: "盈利"
        },
        series: this.symbolProfitSeries
      });
    },
    renderSymbolPieChart: function renderSymbolPieChart() {
      var chart = this.createChart("symbolPieChart");
      if (!chart) return;
      chart.setOption({
        tooltip: {
          trigger: "item"
        },
        legend: {
          bottom: 0,
          type: "scroll"
        },
        series: [{
          name: "交易对订单",
          type: "pie",
          radius: "70%",
          data: this.symbolDistribution.map(function (item) {
            return {
              name: item.name,
              value: item.count
            };
          })
        }]
      });
    },
    createChart: function createChart(refName) {
      var element = this.$refs[refName];
      if (!element) return null;
      var chart = echarts.init(element);
      this.chartInstances.push(chart);
      return chart;
    },
    disposeCharts: function disposeCharts() {
      this.chartInstances.forEach(function (chart) {
        return chart.dispose();
      });
      this.chartInstances = [];
    },
    resizeCharts: function resizeCharts() {
      this.chartInstances.forEach(function (chart) {
        return chart.resize();
      });
    },
    uniqueValues: function uniqueValues(list, key) {
      var values = {};
      list.forEach(function (item) {
        if (item && item[key]) {
          values[item[key]] = true;
        }
      });
      return Object.keys(values).sort();
    },
    toDistribution: function toDistribution(list, key) {
      var _this18 = this;

      var map = {};
      list.forEach(function (item) {
        var name = item[key] || "UNKNOWN";
        map[name] = (map[name] || 0) + 1;
      });
      var max = Math.max.apply(null, Object.values(map).concat([1]));
      return Object.keys(map).map(function (name) {
        return {
          name: name,
          count: map[name],
          percent: _this18.percent(map[name], max)
        };
      }).sort(function (a, b) {
        return b.count - a.count;
      });
    },
    isTrappedOrder: function isTrappedOrder(item) {
      var side = String(item.side || "").toUpperCase();
      var status = String(item.status || "").toUpperCase();
      var hasExecuted = this.toNumber(item.executedQty) > 0 || this.toNumber(item.cummulativeQuoteQty) > 0;
      var isBuyOrder = side === "BUY" || side === "0";
      var isActiveBuy = status === "FILLED" || status === "PARTIALLY_FILLED" || hasExecuted;
      return isBuyOrder && isActiveBuy && Number(item.innerStatus) !== 4;
    },
    getOrderAmount: function getOrderAmount(item) {
      var quoteAmount = this.toNumber(item.cummulativeQuoteQty);
      if (quoteAmount > 0) return quoteAmount;
      return this.toNumber(item.price) * this.toNumber(item.executedQty);
    },
    getTrappedDays: function getTrappedDays(item) {
      if (!item.creationTime) return 0;
      var createdTime = new Date(item.creationTime).getTime();
      if (Number.isNaN(createdTime)) return 0;
      var days = (Date.now() - createdTime) / 86400000;
      return Math.max(0, Math.floor(days));
    },
    getDateKey: function getDateKey(value) {
      if (!value) return "未知日期";
      return String(value).replace("T", " ").substring(0, 10);
    },
    toNumber: function toNumber(value) {
      var number = Number(value);
      return Number.isNaN(number) ? 0 : number;
    },
    round: function round(value) {
      return Number(this.toNumber(value).toFixed(8));
    },
    percent: function percent(value, total) {
      if (!total) return 0;
      return Math.round(Number(value) / Number(total) * 100);
    },
    formatAmount: function formatAmount(value) {
      var number = this.toNumber(value);
      return number.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 8
      });
    },
    formatTime: function formatTime(value) {
      if (!value) return "-";
      return String(value).replace("T", " ").substring(0, 19);
    },
    formatSide: function formatSide(value) {
      if (String(value).toUpperCase() === "BUY") return "买";
      if (String(value).toUpperCase() === "SELL") return "卖";
      return value || "-";
    },
    formatInnerStatus: function formatInnerStatus(value) {
      var item = this.innerStatusOptions.find(function (option) {
        return option.value === Number(value);
      });
      return item ? item.label : value;
    },
    statusTagType: function statusTagType(status) {
      if (status === "FILLED") return "success";

      if (status === "CANCELED" || status === "PARTIALLY_CANCELED") {
        return "danger";
      }

      if (status === "PARTIALLY_FILLED") return "warning";
      return "info";
    },
    loadCurrentUser: function loadCurrentUser() {
      var loginData = extractLoginData();
      this.currentUserName = loginData && loginData[0] ? loginData[0] : "";
    }
  },
  mounted: function mounted() {
    this.loadCurrentUser();

    if (this.canViewPage) {
      this.loadData();
      window.addEventListener("resize", this.resizeCharts);
    }
  },
  beforeUnmount: function beforeUnmount() {
    clearTimeout(this.searchTimer);
    window.removeEventListener("resize", this.resizeCharts);
    this.disposeCharts();
  }
};